import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Result } from 'src/app/shared/class/result.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class SystemServiceService {

	private domain = environment.url_system;
	constructor(private httpClient: HttpClient) {

	}
	public getModules(): Observable<any> {
		return this.httpClient.get(this.domain + '/system/menu');
	}
	public getSubmodules(module:string):Observable<any>{
		return this.httpClient.get(this.domain + `/system/menu/${module}`);
	}
	
	consulta_dni_persona(dni: string){
		const url = `${this.domain}/system/consulta/${dni}`;
		const headers = new HttpHeaders().
				set('Content-Type', 'application/json; charset=utf-8');
		return this.httpClient.get<Result>(url, {headers: headers}).pipe(map(data => data));
	}
}
